import * as React from "react";
import { observer } from "mobx-react";
import { Section } from "../ui/atoms/section";

import { ListVehicles } from "../ui/molecules/list-vehicles";
import { SelectionMode } from "@fluentui/react";
import sizes from "../ui/sizes.scss";
import { store } from "../store";
import { articles } from "../help";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageVehicles extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[articles.truckFleetReport]}
                breadcrumb={store.i18n.t("page.vehicles.title")}
            >
                <Section fill>
                    <ListVehicles
                        includeInactive={false}
                        selectionMode={SelectionMode.none}
                        maxHeight={`${sizes.listMaxHeight}`}
                    />
                </Section>
            </FusionLayout>
        );
    }
}
